import React from 'react'
import { PERMISSION } from 'pages/RequestPurchase/helpers/constants';

const RequestPurchase = React.lazy(() => import('pages/RequestPurchase/pages/RequestPurchase'));
const RequestPurchaseAdd = React.lazy(() => import('pages/RequestPurchase/pages/RequestPurchaseAdd'));
const RequestPurchaseEdit = React.lazy(() => import('pages/RequestPurchase/pages/RequestPurchaseEdit'));
const RequestPurchaseDetail = React.lazy(() => import('pages/RequestPurchase/pages/RequestPurchaseDetail'));

const RequestPurchaseRoutes = [
    {
        path: '/request-purchase',
        exact: true,
        name: 'Danh sách đơn đặt hàng',
        function: PERMISSION.VIEW,
        component: RequestPurchase,
    },
    {
        path: '/request-purchase/add',
        exact: true,
        name: 'Thêm mới đơn đặt hàng',
        function: PERMISSION.ADD,
        component: RequestPurchaseAdd,
    },
    {
        path: '/request-purchase/detail/:id',
        exact: true,
        name: 'Chi tiết đơn đặt hàng',
        function: PERMISSION.VIEW,
        component: RequestPurchaseDetail,
    },
    {
        path: '/request-purchase/edit/:id',
        exact: true,
        name: 'Chỉnh sửa đơn đặt hàng',
        function: PERMISSION.EDIT,
        component: RequestPurchaseEdit,
    },
]

export default RequestPurchaseRoutes
